"use strict";

import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import axios from "axios";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    settingsUserForTool: {},
    settingsGenForTool: {},
    listTools: [],
    appTracks: [],
    settingsGenChanged: false,
    userDataLatestUpdates: []
  },
  getters: {
    settingsUser(state) {
      return state.settingsUserForTool;
    },
    settingsGen(state) {
      return state.settingsGenForTool;
    },
    listTools(state) {
      return state.listTools;
    },
    appTracks(state) {
      return state.appTracks;
    },
    userDataLatestUpdates(state){
      return state.userDataLatestUpdates;
    }
  },
  actions: {
    getOpenAIResponse({ commit, state }, { sysContent, userContent }){
      debugger;
      const model = "gpt-3.5-turbo-0613"; //"gpt-3.5-turbo"
      return new Promise((res, rej) => {
        const chatAPIKey = `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`;

        const httpAIPost = axios.create({
          baseURL: 'https://api.openai.com/v1/chat',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${chatAPIKey}`
          }
        })

        httpAIPost.post('/completions', {
          "model": model,
          "messages": [
            {
              "role": "system",
              "content": sysContent,
            },
            {
              "role": "user",
              "content": userContent,
            },
          ],
          "temperature": 0.7
        }).then(function (response) {
          console.log(response);
           res(response);
        }).catch(function (error) {
          console.log(error);
          rej(error);
        }).finally(() => {

        })
      })
    },
    setSettingsUserForTool({ commit, state }, { settingsUser, toolId }) {
      commit("SET_SETTINGS_USERFORTOOL", { settingsUser, toolId });
    },
    setSettingsGenForTool({ commit, state }, { settingsGen, toolId }) {
      commit("SET_SETTINGS_GENFORTOOL", { settingsGen, toolId });
    },
    setUserDataUpdate({ commit, state }, payload ) {
      commit("SET_USERDATA_UPDATE", payload);
    },
    getLists({ commit, state }, payload) {

        debugger;
     /* const db = firebase.firestore(); //Move to single place
      let collectionRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("lists");
      collectionRef
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            commit("SET_LISTS", doc.data());
          });
        })
        .catch(function(error) {
          //TODO: Store error for stats and Improvements
        });*/
    },
    getToolAppTracksForUser({ commit, state }, payload) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const collectionRef = db
          .collection("users")
          .doc(payload.user.uid)
          .collection("lists")
          .doc("__apps")
          .collection("tracks");

        collectionRef
          .where("appId", "==", payload.toolId) //make it _toolId
          .get()
          .then(function(querySnapshot) {
            let tracks = [];
            querySnapshot.forEach(function(doc) {
              tracks.push(doc.data());
            });
            commit("SET_APP_TRACKS", tracks);
          })
          .catch(function(error) {
            console.some("Add some error handlind");
            //TODO: Store error for stats and Improvements
          });
      });
    },
    getListTools({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let listingsToolsRef = db.collection("listings/tools/items");
        let tools = [];

        listingsToolsRef
          .where("status", "==", "active")
          .get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              tools.push({ toolId: doc.id, ...doc.data() });
            });
            commit("SET_LIST_TOOLS", tools);
          })
          .catch(function(error) {
            console.log("Error getting tools documents: ", error);
          });
        res(tools);
      });
    },
    setTrackerInTool({ commit, state }, payload) {
      const { userUid, focusId, tool, defaultType } = payload;
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let docRef = db.doc(`users/${userUid}/focuses/${focusId}`);
        let toolsRef = db.doc(`users/${userUid}/tags/_tools`);

        res(
          docRef
            .get()
            .then(doc => {
              let toolsInDb = [...doc.data().tools];
              let newTools = toolsInDb.map(el => {
                if (el.tools_id === tool.tools_id) {
                  return tool;
                }
                return el;
              });
              return docRef
                .update({
                  tools: newTools
                })
                .then(() => {
                  console.log("success save update track");
                  if (defaultType) {
                    return toolsRef.get().then(doc => {
                      let items = [...doc.data().items];
                      items = items.map(el => {
                        if (el.uid === tool.tools_id) {
                          return {
                            ...el,
                            default: defaultType
                          };
                        }
                        return el;
                      });
                      return toolsRef
                        .update({
                          items: items
                        })
                        .then(() =>
                          console.log(
                            "successfully save update tools for default tracker"
                          )
                        );
                    });
                  }
                });
            })
            .catch(err => console.log("err in saving tracker default :", err))
        );
      });
    },
    addToolIntoFocus({ commit, rootState }, { tool, focusId }) {
      return new Promise((res, rej) => {
        if (tool && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(rootState.user.user.uid)
            .collection("focuses")
            .doc(focusId);

          focusRef
            .update({
              tools: firebase.firestore.FieldValue.arrayUnion(tool)
            })
            .then(() => {
              console.log("successfully added new tool into a focus");
              res(true);
            })
            .catch(err => {
              console.log("error in adding new tool into focus:", err);
              rej(err);
            });
        }
      });
    },
    editToolInFocus({ commit, rootState }, { tool, focusId }) {
      return new Promise((res, rej) => {
        if (tool && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(rootState.user.user.uid)
            .collection("focuses")
            .doc(focusId);

          res(
            focusRef
              .get()
              .then(doc => {
                let toolFromDatabase = doc.data().tools;
                let toolEdited = toolFromDatabase.map(el => {
                  if (el.tools_id === tool.tools_id) {
                    return tool;
                  } else {
                    return el;
                  }
                });
                return focusRef
                  .update({
                    tools: toolEdited
                  })
                  .then(() => {
                    console.log("successfully edit tool in a focus");
                  });
              })
              .catch(err => {
                console.log("error in editing tool in focus:", err);
              })
          );
        }
      });
    },
    removeToolInFocus({ commit, rootState }, { tools_id, focusId }) {
      return new Promise((res, rej) => {
        if (tools_id && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(rootState.user.user.uid)
            .collection("focuses")
            .doc(focusId);

          res(
            focusRef
              .get()
              .then(doc => {
                let tools = doc.data().tools;
                let toolsToSave = tools.map(el => {
                  if (el.tools_id === tools_id) {
                    return {
                      ...el,
                      _deleted_at: new Date()
                    };
                  } else {
                    return el;
                  }
                });
                return focusRef
                  .update({
                    tools: toolsToSave
                  })
                  .then(() => {
                    console.log("successfully remove tool from a focus");
                  });
              })
              .catch(err => {
                console.log("error in remove tool from focus:", err);
              })
          );
        }
      });
    },
    addVideoIntoYtbTool({ commit, rootState }, { video, focusId, tools_id }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(
          `users/${rootState.user.user.uid}/focuses/${focusId}`
        );
        res(
          focusRef
            .get()
            .then(doc => {
              let tools = [...doc.data().tools];
              let newTools = tools.map(el => {
                if (el.tools_id === tools_id) {
                  if (el.plan && el.plan.videos) {
                    el.plan.videos.push({
                      ...video,
                      _created_by: db.doc(`users/${video._created_by}`)
                    });
                  } else {
                    el.plan = {
                      videos: [
                        {
                          ...video,
                          _created_by: db.doc(`users/${video._created_by}`)
                        }
                      ]
                    };
                  }
                }
                return el;
              });
              return focusRef
                .update({
                  tools: newTools
                })
                .then(() => {
                  console.log("successfully add video into database");
                });
            })
            .catch(err =>
              console.log(`error in add video into database: ${err}`)
            )
        );
      });
    },
    editVideoUrlInYtbTool(
      { commit, rootState },
      { video_url, indexVideo, focusId, tools_id }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(
          `users/${rootState.user.user.uid}/focuses/${focusId}`
        );
        res(
          focusRef
            .get()
            .then(doc => {
              let tools = [...doc.data().tools];
              let newTools = tools.map(el => {
                if (el.tools_id === tools_id) {
                  let { videos } = el.plan;
                  let newVideos = videos.map((e, i) => {
                    if (i === indexVideo) {
                      return {
                        ...e,
                        video_url: video_url
                      };
                    } else {
                      return e;
                    }
                  });
                  return {
                    ...el,
                    plan: {
                      ...el.plan,
                      videos: newVideos
                    }
                  };
                }
                return el;
              });
              return focusRef
                .update({
                  tools: newTools
                })
                .then(() => {
                  console.log("successfully update video in database");
                });
            })
            .catch(err =>
              console.log(`error in update video in database: ${err}`)
            )
        );
      });
    },
    removeVideoInYtbTool(
      { commit, rootState },
      { indexVideo, focusId, tools_id }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(
          `users/${rootState.user.user.uid}/focuses/${focusId}`
        );
        res(
          focusRef
            .get()
            .then(doc => {
              let tools = [...doc.data().tools];
              let newTools = tools.map(el => {
                if (el.tools_id === tools_id) {
                  let { videos } = el.plan;
                  let newVideos = videos.map((el, i) => {
                    if (i === indexVideo) {
                      el._deleted_at = new Date();
                      return el;
                    } else {
                      return el;
                    }
                  });
                  return {
                    ...el,
                    plan: {
                      ...el.plan,
                      videos: newVideos
                    }
                  };
                }
                return el;
              });
              return focusRef
                .update({
                  tools: newTools
                })
                .then(() => {
                  console.log("successfully delte video from database");
                });
            })
            .catch(err =>
              console.log(`error in delete video from database: ${err}`)
            )
        );
      });
    },
    addTrackIntoYtbTool({ commit, rootState }, { track, focusId, tools_id }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(
          `users/${rootState.user.user.uid}/focuses/${focusId}`
        );
        res(
          focusRef
            .get()
            .then(doc => {
              let tools = [...doc.data().tools];
              let newTools = tools.map(el => {
                if (el.tools_id === tools_id) {
                  if (el.tracks && el.tracks.videos) {
                    el.tracks.videos.push({
                      ...track
                    });
                  } else {
                    el.tracks = {
                      videos: [{ ...track }]
                    };
                  }
                }
                return el;
              });
              return focusRef
                .update({
                  tools: newTools
                })
                .then(() => {
                  console.log("successfully add track youtube into database");
                });
            })
            .catch(err =>
              console.log(`error in add track youtube into database: ${err}`)
            )
        );
      });
    },
    addEmoteIntoYtbTool({ commit, rootState }, { emotes, focusId, tools_id }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(
          `users/${rootState.user.user.uid}/focuses/${focusId}`
        );
        res(
          focusRef
            .get()
            .then(doc => {
              let tools = [...doc.data().tools];
              let newTools = tools.map(el => {
                if (el.tools_id === tools_id) {
                  if (el.settings && el.settings.emote) {
                    el.settings.emote.push(...emotes);
                  } else {
                    el.settings = {
                      emotes: [...emotes]
                    };
                  }
                }
                return el;
              });
              return focusRef
                .update({
                  tools: newTools
                })
                .then(() => {
                  console.log("successfully add emotes into database");
                });
            })
            .catch(err =>
              console.log(`error in add emotes into database: ${err}`)
            )
        );
      });
    },
    addTrackIntoEmoteTool({ commit, rootState }, { track, focusId, tools_id }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(
          `users/${rootState.user.user.uid}/focuses/${focusId}`
        );
        res(
          focusRef
            .get()
            .then(doc => {
              let tools = [...doc.data().tools];
              let newTools = tools.map(el => {
                if (el.tools_id === tools_id) {
                  if (el.tracks && el.tracks.emotes) {
                    el.tracks.emotes.push({
                      ...track
                    });
                  } else {
                    el.tracks = {
                      emotes: [{ ...track }]
                    };
                  }
                }
                return el;
              });
              return focusRef
                .update({
                  tools: newTools
                })
                .then(() => {
                  console.log("successfully add track emotes into database");
                });
            })
            .catch(err =>
              console.log(`error in add track emotes into database: ${err}`)
            )
        );
      });
    },
    addMeasureSetting({ commit, rootState }, { measure, focusId, tools_id }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(
          `users/${rootState.user.user.uid}/focuses/${focusId}`
        );
        res(
          focusRef
            .get()
            .then(doc => {
              let tools = [...doc.data().tools];
              let newTools = tools.map(el => {
                if (el.tools_id === tools_id) {
                  if (el.settings && el.settings.measures) {
                    el.settings.measures.push(measure);
                  } else {
                    el.settings = {
                      measures: [measure]
                    };
                  }
                }
                return el;
              });
              return focusRef
                .update({
                  tools: newTools
                })
                .then(() => {
                  console.log("successfully add measures into database");
                });
            })
            .catch(err =>
              console.log(`error in add measures into database: ${err}`)
            )
        );
      });
    },
    addTrackIntoMeasureTool(
      { commit, rootState },
      { track, focusId, tools_id }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(
          `users/${rootState.user.user.uid}/focuses/${focusId}`
        );
        res(
          focusRef
            .get()
            .then(doc => {
              let tools = [...doc.data().tools];
              let newTools = tools.map(el => {
                if (el.tools_id === tools_id) {
                  if (el.tracks && el.tracks.measures) {
                    el.tracks.measures.push({
                      ...track
                    });
                  } else {
                    el.tracks = {
                      measures: [{ ...track }]
                    };
                  }
                }
                return el;
              });
              return focusRef
                .update({
                  tools: newTools
                })
                .then(() => {
                  console.log("successfully add track measures into database");
                });
            })
            .catch(err =>
              console.log(`error in add track measures into database: ${err}`)
            )
        );
      });
    },
    addFreightSetting({ commit, rootState }, { freight, focusId, tools_id }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(
          `users/${rootState.user.user.uid}/focuses/${focusId}`
        );
        res(
          focusRef
            .get()
            .then(doc => {
              let tools = [...doc.data().tools];
              let newTools = tools.map(el => {
                if (el.tools_id === tools_id) {
                  if (el.settings && el.settings.freight) {
                    el.settings.freight.push(freight);
                  } else {
                    el.settings = {
                      _created_at: new Date(),
                      freight: [freight]
                    };
                  }
                }
                return el;
              });
              return focusRef
                .update({
                  tools: newTools
                })
                .then(() => {
                  console.log("successfully add freight into database");
                });
            })
            .catch(err =>
              console.log(`error in add freight into database: ${err}`)
            )
        );
      });
    },
    addTrackIntoFreightTool(
      { commit, rootState },
      { track, focusId, tools_id }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(
          `users/${rootState.user.user.uid}/focuses/${focusId}`
        );
        res(
          focusRef
            .get()
            .then(doc => {
              let tools = [...doc.data().tools];
              let newTools = tools.map(el => {
                if (el.tools_id === tools_id) {
                  if (el.tracks && el.tracks.goods) {
                    el.tracks.goods.push({
                      ...track
                    });
                  } else {
                    el.tracks = {
                      goods: [{ ...track }]
                    };
                  }
                }
                return el;
              });
              return focusRef
                .update({
                  tools: newTools
                })
                .then(() => {
                  console.log("successfully add track emotes into database");
                });
            })
            .catch(err =>
              console.log(`error in add track emotes into database: ${err}`)
            )
        );
      });
    },
    addLogOfTools({ commit, rootState }, { log, focusId, tools_id }) {
      console.log("loh", log);
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(
          `users/${rootState.user.user.uid}/focuses/${focusId}/log`
        );
        res(
          focusRef
            .update({
              log: firebase.firestore.FieldValue.arrayUnion(log)
            })
            .then(function() {
              console.log("CheckIn Logged");
            })
            .catch(function(error) {
              console.error("Error adding  Check-In log: ", error);
            })
          // },
          // let logs = [...doc.data().log];
          // console.log("tools", logs);
          // let newLogs = logs.push(log);
          // let newTools = tools.map(el => {
          //   console.log("el", el);
          //   // if (el.tools_id === tools_id) {
          //   if (el.tracks && el.tracks.videos) {
          //     // el.tracks.videos.push({
          //     //   ...track
          //     // });
          //   } else {
          //     el.tracks = {
          //       // videos: [{ ...track }]
          //     };
          //   }
          //   // }
          //   return el;
          // });
          // console.log("toolxxs", logs);
          // return focusRef
          //   .update({
          //     log: newLogs
          // })
          // .then(() => {
          //   console.log("successfully add track youtube into database");
          // });
          //     })
          //     .catch(err =>
          //       console.log(`error in add track youtube into database: ${err}`)
          //     )
        );
      });
    }
  },
  //synchronous
  mutations: {
    SET_SETTINGS_USERFORTOOL(state, { settingsUser, toolId }) {
      let toolIdx = `tool_${toolId}`;

      if (!state.settingsUserForTool[toolIdx]) {
        state.settingsUserForTool[toolIdx] = {};
        state.settingsUserForTool[toolIdx]._created_at = new Date();
      }

      state.settingsUserForTool[toolIdx]._updated_at = new Date();
      state.settingsUserForTool[toolIdx].settings = settingsUser;
    },
    SET_SETTINGS_GENFORTOOL(state, { settingsGen, toolId }) {
      let toolIdx = `tool_${toolId}`;

      if (!state.settingsGenForTool[toolIdx]) {
        state.settingsGenForTool[toolIdx] = {};
        state.settingsGenForTool[toolIdx]._created_at = new Date();
      }

      state.settingsGenForTool[toolIdx]._updated_at = new Date();
      state.settingsGenForTool[toolIdx].settings = settingsGen;
    },
    SET_LIST_TOOLS(state, listTools) {
      if (listTools) {
        state.listTools = listTools;
      } else {
        state.listTools = [];
      }
    },
    SET_APP_TRACKS(state, tracks) {
      if (tracks) {
        state.appTracks = tracks;
      } else {
        state.appTracks = [];
      }
    },
    SET_USERDATA_UPDATE(state, payload){
      //Clear Old
      if (state.userDataLatestUpdates.length > 5 )
        state.userDataLatestUpdates.shift();
      //Add new
      state.userDataLatestUpdates.push(payload);
    }
  }
};
